import { T, C } from '@homeschooling/sdk'

import * as React from 'react'
import * as _ from 'lodash'

import m from 'moment'

import Persistance from "../Persistence";

export interface Props {
    children?: React.ReactNode
    note: T.Progress
    position: number
}
  
export interface State {
    students: T.Student[],
    focus: boolean
}

Persistance.setValues()

export class NotesRow extends React.Component<Props, any> {

    public constructor (props: Props) {
        super(props)
    
        this.state = {
          students: Persistance.getStudents(),
          focus: false
        }
      }

    public showNote = () => {
        this.setState({focus: true})
    }

    public getStudentFromId = (id: string | number) => {

        return _.find(this.state.students, {id: Number(id)})

    }
  

  public render(): React.ReactNode {
    const note = this.props.note
    const student = note.students ? note.students[0] : {name: ''}

    const background = this.props.position % 2 === 0 ? '' : 'bg-slate-100'

    return (
        <div id={`note${note.id}`} className={`flex text-main items-center flex-row justify-left h-auto ${background} py-3`}>
        <div className='w-12 flex flex-row items-center text-left text-xs flex-none'>
          <div className='w-12 items-center flex-none pr-2'>
            <div className='flex items-center flex-none h-auto'>
              <img title= {student.name} alt={student.name} className="object-cover w-8 h-8 rounded-full" src="https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=faceare&facepad=3&w=688&h=688&q=100" />
            </div>
          </div>
        </div>  
        <div className='w-12 grow text-left flex-none align-middle text-gray-600 text-s px-2'>
           {note.description}
        </div>
        <div className='w-36 text-left text-sm align-middle flex-none'>
        {C.subject[note.subject].label}
        </div>
        <div className='w-36 text-sm align-middle text-left px-2 flex-none'>
            {C.getSubjectConstants(note.subject)[note.course].label}
        </div>
        <div className='w-28 text-center text-sm align-middle flex-none'>
          {m(note.date).format('MMM DD YYYY')}
        </div>
    </div>
    )
  }  
  
}

export default NotesRow